import React, { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/Navbar/Navbar";
import {
  Breadcrumb,
  Button,
  Drawer,
  Modal,
  Select,
  Input,
  Checkbox,
  Spin,
  Radio,
  AutoComplete,
} from "antd";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import {
  cashInOutReport,
  getCreditHistory,
  getPosOrderLines,
  posOrders,
} from "../../API  Functions/SessionHistoryFunctions";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import DateFilter from "../../components/ui/DateFilter";
import dayjs from "dayjs";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import i18next from "i18next";
import { toast } from "react-toastify";
import moment, { lang } from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import { AddBox } from "@mui/icons-material";
import { Plus } from "lucide-react";
import {
  getGroupProducts,
  getProductGroups,
} from "../../API  Functions/productGroupFunctions";
import VatTable from "./VatTable";
import AddProductToVAT from "./AddProductsToVatModal";
import { DeleteOutlined } from "@ant-design/icons";
import {
  getInventoryallproducts,
  InventorySearchonboardBarcode,
} from "../../API  Functions/InventoryFunctions";
import {
  CloseOutlined,
  DoubleRightOutlined,
  LoadingOutlined,
  SearchOutlined,
  DownloadOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { MultiSelectBox } from "../CustomWidgets/SelectBox";
import VatProductsTable from "./VatProductsTable";

const VatProductsScreen = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [vatName, setVatName] = useState("");
  const [vatPercentage, setVatPercentage] = useState("");
  const [mainLoading, setMainLoading] = useState(false);

  const [vatTypes, setVatTypes] = useState([]);
  const [createOpen, setCreateOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const [Loading, setLoading] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [drawerData, setDrawerData] = useState(null);
  const [orderLines, setOrderLines] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [addVatDrawerOpen, setAddVatDrawerOpen] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedVatType, setSelectedVatType] = useState(null);
  const [vatPriceType, setVatPriceType] = useState(null);
  const userData = useSelector((state) => state?.login?.user?.result);
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [searching, setSearching] = useState(false);
  const [Productoptions, setProductoptions] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [allProductsWithVat, setAllProductsWithVat] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [allGroups, setAllGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedCategoies, setSelectedCategoies] = useState([]);
  const [selectedSubCategoies, setSelectedSubCategoies] = useState(['ALL']);
  const [vatApplyOn, setVatApplyOn] = useState("product");
  const [query, setquery] = useState("");
  const [searchByShortCode, setSearchByShortCode] = useState(false);

  useEffect(() => {
    GetProductsWithTaxes('');
  }, [currentLimit, currentOffset]);

  useEffect(() => {
    GetVatTypes();
    GetCategories();
    GetAllGroups();
  }, []);

  const GetProductsWithTaxes = async (text) => {
    const payload = {
      retailer_id: company_id,
      offset: currentOffset,
      limit: currentLimit,
      search: !searchByShortCode ? text : '',
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
      short_code : searchByShortCode ? text : ''
    };
    try {
      const res = await axiosInstance.post(
        URLS.GET_ALL_PRODUCTS_WITH_VAT,
        payload,
      );
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setAllProductsWithVat(res1?.result?.data);
      } else {
        setAllProductsWithVat([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const GetVatTypes = async () => {
    const payload = {
      retailer_id: company_id,
      offset: 0,
      limit: 1000,
    };
    try {
      const res = await axiosInstance.post(URLS.GET_VAT_TYPES, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
      setVatTypes(res1?.result?.data?.filter(item => item.is_active));
      } else {
        setVatTypes([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const GetCategories = async () => {
    const payload = {
      retailer_id: company_id,
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
      search: "",
    };
    try {
      const res = await axiosInstance.post(URLS.GET_VAT_CATEGORIES, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setAllCategories(res1?.result?.data);
      } else {
        setAllCategories([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const GetAllGroups = () => {
    let payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
      user_id: user_id,
      offset: 0,
      limit: 1000,
    };
    getProductGroups(payload).then((res1) => {
      // console.log("CATEGORY RESPONSE --->", res);
      if (res1?.result[0]?.status_code === 200) {
        setAllGroups(res1?.result[0]?.product_groups);
      } else {
        setAllGroups([]);
      }
    });
  };

  const GetSubCategories = async (values) => {
    const payload = {
      retailer_id: company_id,
      parent_categ_ids: values,
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
      search: "",
    };
    try {
      const res = await axiosInstance.post(
        URLS.GET_VAT_SUB_CATEGORIES,
        payload,
      );
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setAllSubCategories(res1?.result?.data);
      } else {
        setAllSubCategories([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  // const handleRowClick = async (order) => {
  //     setDrawerVisible(true);
  //     setDrawerLoading(true);
  //     setDrawerData(order);

  //     // console.log("vdfggv", order);

  //     try {
  //         const payload = {
  //             lang: i18n.language === "ar" ? "ar_001" : "en_US",
  //             company_id: company_id,
  //             user_id: user_id,
  //             group_id: order.id,
  //         };
  //         const res = await getGroupProducts(payload);

  //         // console.log("resresresres---->", res);

  //         if (res?.result[0]?.status_code === 200) {
  //             setOrderLines(res?.result[0]?.product_list || []);
  //         } else {
  //             setOrderLines([]);
  //         }
  //     } catch (error) {
  //         console.error("Error fetching order lines:", error);
  //     } finally {
  //         setDrawerLoading(false);
  //     }
  // };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery.length === 0 || searchQuery.length > 2)
        getProducts(searchQuery);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const getProducts = async (val = "") => {
    setLoading(true);
    try {
      const payload = {
        user_id: userData?.user_id,
        company_id: userData?.company_id,
        category_id: false,
        product_name: val,
        limit: 10,
        offset: 0,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      const res = await axiosInstance.post(URLS.GET_ALL_PRODUCTS, payload);
      //   console.log("PRIODYCYD", res);

      const result = res?.data?.result[0]?.response || [];
      setProductoptions(result);
    } catch (err) {
      console.error("Error fetching products:", err);
      setProductoptions([]);
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    setAddVatDrawerOpen(false);
    // setDrawerVisible(false);
    setSelectedGroup(null);
    setSelectedCategoies([]);
    setSelectedSubCategoies(['ALL']);
    setProductList([]);
    setSelectedVatType(null)
    setVatPriceType(null)
  };

  const handleCreateVat = async () => {
    if (loading) return;
    
    if (!vatName || !vatPercentage) {
      toast.error(t("Please fill all fields"));
      return;
    }

    try {
      setLoading(true);

      const payload = {
        retailer_id: company_id,
        tax_name: vatName,
        tax_rate_percent: vatPercentage,
        is_tax_price_inclusive: false,
      };

      const res = await axiosInstance.post(URLS.CREATE_VAT_TYPE, payload);
      const result = res?.data?.result;

      if (result?.status_code === 200) {
        toast.success(t("Tax type created successfully"));
        setCreateOpen(false);
    GetVatTypes();

        setVatName("");
        setVatPercentage("");
        // GetVatTypes(); // refresh list if needed
      } else {
        toast.error(result?.status || t("Failed to create Tax type"));
      }
    } catch (error) {
      console.error(error);
      toast.error(t("Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (subStoreId, currentStatus) => {
    const newStatus = !currentStatus;
    setMainLoading(true);
    try {
      let payload = {
        retailer_id: company_id,
        tax_id: subStoreId,
        is_active: newStatus,
      };
      const res = await axiosInstance.post(URLS.UPDATE_VAT, payload);
      if (res?.data?.result?.status_code == 200) {
        if (currentStatus) {
          toast.success(t("Tax type disabled."));
        } else {
          toast.success(t("Tax type enabled."));
        }
        GetVatTypes();
      }
      // const result = res?.data?.result;

      // toast.success(t("Branch activated successfully"));
    } catch (error) {
      console.error(error);
      toast.error(t("Error toggling status"));
    } finally {
      setMainLoading(false);
    }
  };

  const toggleProduct = (id) => {
    setSelectedProducts((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };

  const handleClose = () => {
    setSelectedProducts([]);
    setShowDropdown(false);
    onClose?.();
  };

  const handleSave = () => {
    // if (englishName.trim() === "" || arabicName.trim() === "") {
    //   toast.error(t("Please enter both English and Arabic group names."));
    //   return;
    // }

    // if (selectedProducts.length === 0) {
    //   toast.error(t("Please select at least one product."));
    //   return;
    // }
    // onSave?.({
    //   englishName,
    //   arabicName,
    //   selectedProducts,
    // });
    handleClose();
  };

  const searchResult = useCallback(
    debounce(async (value) => {
      setSearching(true); // start loader
      try {
        let payload = {};
        const response = await getInventoryallproducts(
          user_id,
          company_id,
          false,
          false,
          value,
          10,
          0,
        );
        console.log("response==>", response);

        if (response?.result[0]?.response) {
          setProductoptions(response.result[0].response);
        } else {
          setProductoptions([]);
        }
      } catch (error) {
        console.error(error);
        setProductoptions([]);
      } finally {
        setSearching(false); // stop loader always
      }
    }, 1000),
    [],
  );

  const handleProductSelect = (value) => {
    const selectedProduct = Productoptions.find(
      (product) => product.product_name === value,
    );

    if (selectedProduct) {
      // Check if the product has a barcode
      if (!selectedProduct.barcode) {
        // If no barcode, open the modal to input the barcode
        setSelectedProduct(selectedProduct);
        setSelectedProductId(selectedProduct.quant_id);
        return; // Exit the function to prevent adding the product
      }
    }

    if (selectedProduct) {
      // Check if the product is already in the productList
      const isDuplicate = productList.some(
        (product) => product.quant_id === selectedProduct.quant_id, // Assuming prod_id is unique
      );

      if (isDuplicate) {
        // Optionally, show a message to the user
        toast.error(`${selectedProduct.product_name} is already in the list.`); // Replace with a more user-friendly message or modal if needed
        return;
      }

      const productWithQty = {
        ...selectedProduct,
      };
      setSelectedProduct(productWithQty);
      setProductList([...productList, productWithQty]);
      // setSearchQuery("");
      // setProductoptions([]);
    }
  };
  // console.log("Order Lines Response:", orderLines);

  const handleRemoveProduct = (quant_id) => {
    setProductList((prev) => prev.filter((p) => p.quant_id !== quant_id));
  };

  const CreateTax = () => {
    if (vatApplyOn == "product") {
      handleAllVatToProducts();
    } else if (vatApplyOn == "category") {
      handleAllVatToCategory();
    } else if (vatApplyOn == "group") {
      handleAllVatToGroups();
    }
  };

  const handleAllVatToProducts = async () => {
    if (!selectedVatType || !vatPriceType) {
      toast.error(t("Please fill all fields"));
      return;
    }
    if (productList?.length < 1) {
      toast.error(t("Please add products"));
      return;
    }

    try {
      setLoading(true);

      const payload = {
        retailer_id: company_id,
        tax_id: selectedVatType,
        is_all_product: false,
        product_ids: productList?.map((item) => item.quant_id),
        is_tax_price_inclusive: vatPriceType == "exclusive" ? false : true,
      };

      const res = await axiosInstance.post(URLS.ADD_VAT_TO_PRODUCTS, payload);
      const result = res?.data?.result;

      if (result?.status_code === 200) {
        toast.success(t("Tax Added successfully"));
        onClose();
        GetProductsWithTaxes();
        // setCreateOpen(false);
        // setVatName("");
        // setVatPercentage("");
        // GetVatTypes(); // refresh list if needed
      } else {
        toast.error(result?.status || t("Failed to add Tax"));
      }
    } catch (error) {
      console.error(error);
      toast.error(t("Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  const handleAllVatToCategory = async () => {
    if (!selectedVatType || !vatPriceType) {
      toast.error(t("Please fill all fields"));
      return;
    }
    if (selectedCategoies?.length < 1) {
      toast.error(t("Please add categories"));
      return;
    }
    try {
      setLoading(true);

      const payload = {
        retailer_id: company_id,
        tax_id: selectedVatType,
        is_all_categ: false,
        category_ids: selectedCategoies,
        sub_category_ids: selectedSubCategoies[0] == "ALL" ? [] : selectedSubCategoies,
        is_tax_price_inclusive: vatPriceType == "exclusive" ? false : true,
      };

      const res = await axiosInstance.post(URLS.ADD_VAT_TO_CATEGORY, payload);
      const result = res?.data?.result;

      if (result?.status_code === 200) {
        toast.success(t("Tax Added successfully"));
        onClose();
        GetProductsWithTaxes();

        // setCreateOpen(false);
        // setVatName("");
        // setVatPercentage("");
        // GetVatTypes(); // refresh list if needed
      } else {
        toast.error(result?.status || t("Failed to create Tax type"));
      }
    } catch (error) {
      console.error(error);
      toast.error(t("Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  const handleAllVatToGroups = async () => {
    if (!selectedVatType || !vatPriceType) {
      toast.error(t("Please fill all fields"));
      return;
    }
    if (selectedGroup?.length < 1) {
      toast.error(t("Please add groups"));
      return;
    }
    try {
      setLoading(true);

      const payload = {
        retailer_id: company_id,
        tax_id: selectedVatType,
        is_all_group: false,
        group_ids: selectedGroup,
        is_tax_price_inclusive: vatPriceType == "exclusive" ? false : true,
      };
      console.log("payload===>",payload);
      

      const res = await axiosInstance.post(
        URLS.CREATE_PRODUCT_GROUP_TAX,
        payload,
      );
      const result = res?.data?.result;

      if (result?.status_code === 200) {
        toast.success(t("Tax Added successfully"));
        onClose();
        GetProductsWithTaxes();
        // setCreateOpen(false);
        // setVatName("");
        // setVatPercentage("");
        // GetVatTypes(); // refresh list if needed
      } else {
        toast.error(result?.status || t("Failed to create Tax type"));
      }
    } catch (error) {
      console.error(error);
      // toast.error(t("Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {mainLoading && <LoadingSpinner />}

      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="Add Product Taxes" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3 mt-2">
          <div className="font-extrabold mb-3"></div>

          <div className=" mt-3">
            <div className="flex justify-between items-center">

            <div className="flex gap-x-2 items-center">
               <SearchBox
                          showBarcode={true}
                          searchResult={(values) => {
                            setquery(values);
                            GetProductsWithTaxes(values)
                          }}
                          placeholder={
                            searchByShortCode
                              ? t("Search Short Code")
                              : t("Search Products")
                          }
                          width={"300px"}
                          value={query}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (searchByShortCode) {
                              // debouncedSearch("");
                            }
                            setSearchByShortCode(!searchByShortCode);
                          }}
                          className={`h-[40px] px-2  rounded-md border text-sm whitespace-nowrap
                ${
                  searchByShortCode
                    ? "bg-blue-100 border-primaryBlue text-primaryBlue"
                    : "bg-white border-gray-300 text-gray-700"
                }`}
                        >
                          {t("Search Code")}
                        </button>
            </div>
            
            <div className=" flex justify-end mt-3 mx-8">
              <button
                className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg mx-2 flex items-center justify-center gap-2"
                // onClick={() => setCreateOpen(true)}
                onClick={() => {
                  if (checkPermission("/settings/taxes", isGinne)) {
                    setCreateOpen(true);
                  }
                }}
              >
                <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} />

                <span>{t("Create Tax")}</span>
              </button>
              <button
                className="w-40 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                // onClick={() => setCreateOpen(true)}
                onClick={() => {
                  if (checkPermission("/settings/taxes", isGinne)) {
                    setAddVatDrawerOpen(true);
                  }
                }}
              >
                {/* <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} /> */}

                <span>{t("Add Tax")}</span>
              </button>
            </div>
            </div>

            {loading ? (
              <ShimmerLoader />
            ) : (
              <>
                <VatProductsTable
                  additionalData={allProductsWithVat}
                  pagination={(values) => {
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                  }}
                  vatTypes={vatTypes}
                  upadateTable={()=>{
                    GetProductsWithTaxes(query);
                  }}
                  // onToggleStatus={handleToggleStatus}
                  // onRowClick={handleRowClick}
                  // onDelete={confirmDelete}
                  // onSaveEdit={(updatedRow) => {
                  //     handleEditSave(updatedRow);
                  // }}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {/* Drawer */}
      {/* {<AddProductToVAT 
    open={addVatDrawerOpen}
    onClose={()=>setAddVatDrawerOpen(false)}
    vatTypes={vatTypes}
    />} */}
      {/* Drawer */}
      <Drawer
        open={addVatDrawerOpen}
        onClose={() => onClose()}
        placement="right"
        width={450}
        closable={false}
        bodyStyle={{ padding: 0 }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 px-6 py-4 border-b">
  <button
    onClick={() => onClose()}
    className="text-lg font-bold"
  >
    {i18n.language === "ar" ? "→" : "←"}
  </button>

  <h2 className="text-lg font-semibold">
    {t("Add Tax Type")}
  </h2>
</div>
        {/* Top Tabs */}
        <div className="flex gap-6 px-6 pt-4 border-b w-full ">
          {[
            { key: "product", label: t("Product") },
            { key: "category", label: t("Category") },
            { key: "group", label: t("Group") },
          ].map((item) => (
            <button
              key={item.key}
              onClick={() => setVatApplyOn(item.key)}
              className={`pb-3 w-4/12 text-sm font-semibold relative ${
                vatApplyOn === item.key ? "text-primaryBlue" : "text-gray-400"
              }`}
            >
              {item.label}
              {vatApplyOn === item.key && (
                <span className="absolute left-0 right-0 -bottom-[1px] h-[3px] bg-primaryBlue rounded-full" />
              )}
            </button>
          ))}
        </div>
        {vatApplyOn === "product" && (
          <>
            <div className="px-3 mt-4">
              <div className="mb-3">
                <h3 className="text-sm font-semibold mb-2 text-gray-600">
                  {t("Tax")}
                </h3>
                <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select Tax")}
                  className="h-10"
                  value={selectedVatType}
                  onChange={(value) => setSelectedVatType(value)}
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  options={vatTypes.map((vat) => ({
                      label: `${vat.tax_name} (${vat.tax_rate_percent}%)`,
                    value: vat.id,
                  }))}
                />
              </div>
              <div className="mb-3">
                <h3 className="text-sm font-semibold mb-2 text-gray-600">
                  {t("Tax Type")}
                </h3>

                <Radio.Group
                  value={vatPriceType}
                  onChange={(e) => setVatPriceType(e.target.value)}
                >
                  <Radio value="exclusive">{t("Exclusive")}</Radio>
                  <Radio value="inclusive">{t("Inclusive")}</Radio>
                </Radio.Group>
              </div>

              {/* Product Dropdown Section */}
              <div className="mb-8 relative">
                <label className="block text-sm mb-2 font-semibold text-gray-600">
                  {t("Product List")}
                </label>

                <span className="relative w-8/12">
                  <AutoComplete
                    value={searchQuery}
                    style={{ width: "100%", height: "43px", outline: "none" }}
                    open={showDropdown}
                    onDropdownVisibleChange={(open) => setShowDropdown(open)}
                    options={Productoptions.map((prod) => ({
                      value: prod.product_name,
                      label: (
                        <div className="flex justify-between items-center">
                          <span>{prod.product_name}</span>
                          {productList.some(
                            (p) => p.quant_id === prod.quant_id,
                          ) && (
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#16A34A"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                          )}
                        </div>
                      ),
                      disabled: productList.some(
                        (p) => p.quant_id === prod.quant_id,
                      ),
                    }))}
                    filterOption={false}
                    onSearch={(val) => {
                      setSearchQuery(val);
                      if (val.length >= 2) {
                        searchResult(val);
                        setShowDropdown(true); // keep open while typing
                      } else {
                        setProductoptions([]);
                        setShowDropdown(false);
                      }
                    }}
                    onSelect={(val) => {
                      setTimeout(() => setShowDropdown(true), 0);

                      handleProductSelect(val);

                      // Delay a tick to reopen dropdown
                    }}
                  >
                    <Input
                      placeholder={t("search_product")}
                      size="large"
                      style={{
                        borderColor: "#d9d9d9", // remove border
                        boxShadow: "none", // remove hover/focus glow
                      }}
                      suffix={
                        searchQuery ? (
                          <CloseOutlined
                            onClick={() => {
                              setShowDropdown(true); // keep dropdown open after clearing
                              setSearchQuery(false);
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        ) : (
                          <SearchOutlined />
                        )
                      }
                    />
                  </AutoComplete>
                </span>
              </div>
              {productList?.length > 0 && (
                <div className=" bg-gray-50 rounded-xl pt-2 mb-3">
                  <h3 className="text-sm font-semibold text-gray-700 mb-4 mx-3">
                    {t("Added Products")}
                  </h3>

                  <div className="">
                    {productList.map((product) => (
                      <div
                        key={product.quant_id}
                        className="flex items-center justify-between bg-white px-3 py-2 shadow-sm"
                      >
                        {/* Left side */}
                        <div className="flex items-center gap-x-3">
                          <img
                            src={product.product_image_url}
                            alt={product.product_name}
                            className="w-10 h-10 rounded-md object-cover bg-gray-100"
                          />

                          <div>
                            <p className="text-sm font-medium text-gray-800">
                              {product.product_name}
                            </p>
                            <p className="text-xs text-gray-500">
                              {product.barcode || product.quant_id}
                            </p>
                          </div>
                        </div>

                        {/* Delete */}
                        <button
                          onClick={() => handleRemoveProduct(product.quant_id)}
                          className="text-gray-400 hover:text-red-500 transition"
                        >
                          <DeleteOutlined />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Save Button */}
              <div className="flex justify-end gap-4">
                <button
                  onClick={onClose}
                  className={`px-8 py-2 font-semibold text-xs border rounded-lg bg-white text-primaryBlue border-primaryBlue hover:bg-red-600`}
                >
                  {t("Cancel")}
                </button>
                <button
                  onClick={CreateTax}
                  className={`px-8 py-2 font-semibold text-xs border rounded-lg bg-primaryBlue text-white border-primaryBlue hover:bg-red-600`}
                >
                  {t("Save")}
                </button>
              </div>
            </div>
          </>
        )}
        {vatApplyOn == "category" && (
          <div className="px-3 mt-4">
            <div className="mb-3">
              <h3 className="text-sm font-semibold mb-2 text-gray-600">
                {t("Tax")}
              </h3>
              <Select
                style={{ width: "100%" }}
                placeholder={t("Select Tax")}
                className="h-10"
                value={selectedVatType}
                onChange={(value) => setSelectedVatType(value)}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                options={vatTypes.map((vat) => ({
                     label: `${vat.tax_name} (${vat.tax_rate_percent}%)`,
                  value: vat.id,
                }))}
              />
            </div>
            <div className="mb-3">
              <h3 className="text-sm font-semibold mb-2 text-gray-600">
                {t("Tax Type")}
              </h3>

              <Radio.Group
                value={vatPriceType}
                onChange={(e) => setVatPriceType(e.target.value)}
              >
                <Radio value="exclusive">{t("Exclusive")}</Radio>
                <Radio value="inclusive">{t("Inclusive")}</Radio>
              </Radio.Group>
            </div>
            <div className=" mb-6">
              <MultiSelectBox
                label={t("Categories")}
                name="categories"
                onChange={(event) => {
                  setSelectedCategoies(event.target.value);
                  GetSubCategories(event.target.value);
                }}
                placeholder={t("Select Categories")}
                value={selectedCategoies}
                options={[
                  ...allCategories?.map((item) => ({
                    value: item?.id,
                    label: item?.name,
                  })),
                ]}
              />
              {selectedCategoies?.length > 0 && (
                <MultiSelectBox
                  label={t("Sub-Categories")}
                  name="subcategories"
          onChange={(event) => {
      let value = event.target.value || [];

      // 🟢 If nothing selected → auto select ALL
      if (value.length === 0) {
        setSelectedSubCategoies(["ALL"]);
        return;
      }

      const lastSelected = value[value.length - 1];

      // 🟢 If ALL selected → keep only ALL
      if (lastSelected === "ALL") {
        setSelectedSubCategoies(["ALL"]);
        return;
      }

      // 🟢 If any other selected → remove ALL
      setSelectedSubCategoies(value.filter(v => v !== "ALL"));
    }}
                  placeholder={t("Select Sub-Categories")}
                  value={selectedSubCategoies}
                  options={[
                    {
        value: "ALL",
        label: t("All Sub-Categories"),
      },
                    ...allSubCategories?.map((item) => ({
                      value: item?.id,
                      label: item?.name,
                    })),
                  ]}
                />
              )}
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-4">
              <button
                onClick={onClose}
                className={`px-8 py-2 font-semibold text-xs border rounded-lg bg-white text-primaryBlue border-primaryBlue hover:bg-red-600`}
              >
                {t("Cancel")}
              </button>
              <button
                onClick={CreateTax}
                className={`px-8 py-2 font-semibold text-xs border rounded-lg bg-primaryBlue text-white border-primaryBlue hover:bg-red-600`}
              >
                {t("Save")}
              </button>
            </div>
          </div>
        )}
        {vatApplyOn == "group" && (
          <div className="px-3 mt-4">
            <div className="mb-3">
              <h3 className="text-sm font-semibold mb-2 text-gray-600">
                {t("Tax")}
              </h3>
              <Select
                style={{ width: "100%" }}
                placeholder={t("Select Tax")}
                className="h-10"
                value={selectedVatType}
                onChange={(value) => setSelectedVatType(value)}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                options={vatTypes.map((vat) => ({
                  label: `${vat.tax_name} (${vat.tax_rate_percent}%)`,
                  value: vat.id,
                }))}
              />
            </div>
            <div className="mb-3">
              <h3 className="text-sm font-semibold mb-2 text-gray-600">
                {t("Tax Type")}
              </h3>

              <Radio.Group
                value={vatPriceType}
                onChange={(e) => setVatPriceType(e.target.value)}
              >
                <Radio value="exclusive">{t("Exclusive")}</Radio>
                <Radio value="inclusive">{t("Inclusive")}</Radio>
              </Radio.Group>
            </div>
            <div className=" mb-6">
              <MultiSelectBox
                label={t("Groups")}
                name="groups"
                onChange={(event) => {
                  setSelectedGroup(event.target.value);
                }}
                placeholder={t("Select Groups")}
                value={selectedGroup}
                options={[
                  ...allGroups?.map((item) => ({
                    value: item?.id,
                    label: item?.name,
                  })),
                ]}
              />
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-4">
              <button
                onClick={onClose}
                className={`px-8 py-2 font-semibold text-xs border rounded-lg bg-white text-primaryBlue border-primaryBlue hover:bg-red-600`}
              >
                {t("Cancel")}
              </button>
              <button
                onClick={CreateTax}
                className={`px-8 py-2 font-semibold text-xs border rounded-lg bg-primaryBlue text-white border-primaryBlue hover:bg-red-600`}
              >
                {t("Save")}
              </button>
            </div>
          </div>
        )}
      </Drawer>

      {/* Confirmation Modal */}
      {/* <Modal
                open={showConfirmModal}
                onCancel={() => setShowConfirmModal(false)}
                footer={null}
                centered
                closable={false}
            >
                <div className="text-center p-6">
                    <h3 className="text-lg font-semibold mb-4 text-gray-800">
                        {t("Are you sure you want to delete this group ?")}
                    </h3>
                    <div className="flex justify-center gap-4 mt-6">
                        <button
                            onClick={() => setShowConfirmModal(false)}
                            className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
                        >
                            {t("No")}
                        </button>
                        <button
                            onClick={() => handleGroupDelete(selectedGroup)}  // ✅ fixed line
                            disabled={loading}
                            className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
                        >
                            {loading ? t("Removing...") : t("Yes")}
                        </button>
                    </div>
                </div>
            </Modal> */}

      <Modal
        open={createOpen}
        onCancel={() => {
            setVatName('');
          setVatPercentage('');
          setCreateOpen(false)}}
        centered
        title={t("Create Tax")}
        footer={null}
      >
        <div className="space-y-4">
          {/* Tax Name */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Tax Name")}
            </label>
            <input
              type="text"
              value={vatName}
              onChange={(e) => setVatName(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none"
              placeholder={t("Enter Tax name")}
              maxLength={50}
            />
          </div>

          {/* Tax Percentage */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Tax Percentage")}
            </label>
            <input
              type="number"
              min="0"
              max="100"
              value={vatPercentage}
              onChange={(e) => {
                const value = e.target.value;

                if (value === "") {
                  setVatPercentage("");
                  return;
                }

                const num = Number(value);

                if (num >= 0 && num <= 100 && /^\d*\.?\d{0,2}$/.test(value)) {
                  setVatPercentage(num);
                }
              }}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none"
              placeholder={t("Enter Tax percentage")}
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 pt-4">
            <button
              onClick={() => {
                  setVatName('');
          setVatPercentage('');
                setCreateOpen(false)}}
              className="px-4 py-2 rounded-lg border text-gray-600 hover:bg-gray-100"
            >
              {t("Cancel")}
            </button>

            <button
              onClick={handleCreateVat}
              disabled={loading}
              className="px-6 py-2 rounded-lg bg-primaryBlue text-white font-semibold hover:opacity-90"
            >
              {loading ? t("Creating...") : t("Create")}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default VatProductsScreen;
